import React from "react";
import { t } from "i18next";
import { ICON_BASE_PATH } from "@/app/utils/config";

interface NoDataFoundProps {
  message?: string;
  className?: string;
  submessage?: string;
  iconType?: number;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  message = "noDataFound",
  submessage,
  className,
  iconType = 1,
}) => {
  return (
    <div className={`${className ?? ""} gx-no-data-found-container`}>
      <div className="gx-no-data-found-wrapper">
        <div className="gx-datanot-error-child">
          <div className="gx-datanot-error">
            <img
              src={
                iconType == 1
                  ? `${ICON_BASE_PATH}notfound.svg`
                  : `${ICON_BASE_PATH}search-no-data-icon.svg`
              }
              alt="Warning"
            />
          </div>
          <div>
            <p className="gx-datanot-errormessage gx-p18-sb">
              {t(message)} <span className="gx-p12-m">{submessage}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoDataFound;
